import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class ProviderOfficeHoursModel extends BaseModel {
  static urlPath = "provider_office_hours";

  @attr("string") startTime;
  @attr("string") endTime;
  @attr("string") day;
  @attr("string") provider;
  @attr("datetime") createdAt;
  @belongsTo("client") createdBy;
  @attr("datetime") updatedAt;
  @belongsTo("client") updatedBy;
}
